import { __rest } from "tslib";
import * as React from 'react';
import { Button, ButtonVariant } from '../Button';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationBadge/notification-badge';
export var NotificationBadge = function NotificationBadge(_a) {
  var _a$isRead = _a.isRead,
      isRead = _a$isRead === void 0 ? false : _a$isRead,
      className = _a.className,
      children = _a.children,
      props = __rest(_a, ["isRead", "className", "children"]);

  return React.createElement(Button, Object.assign({
    variant: ButtonVariant.plain,
    className: className
  }, props), React.createElement("span", {
    className: css(styles.notificationBadge, isRead ? styles.modifiers.read : styles.modifiers.unread)
  }, children));
};